<template>
  <loading-icon v-if="loading" class="c-card"></loading-icon>

  <div v-else class="c-card c-card--quizzes">
    <div class="c-card__header">
      <h2 class="c-card__title t-headline">{{ card.title }}</h2>
    </div>

    <div class="c-card__body">
      <template v-if="quizzesUntaken.length" class="c-card--quizzes__untaken-list">
        <ol class="c-card--quizzes__untaken-list">
          <li v-for="(quiz, i) in quizzesUntaken">
            <!--
                Using `button`s breaks `justify-content: space-between` on
                macOS Sierra Safari v10.1.
            -->
            <div
              @click = "showModal(quiz.code)"
              class  = "c-card--quizzes__untaken-list__single qa-open-modal-button"
            >
              {{ quiz.name }}
              <i class="fa fa-arrow-right c-card--quizzes__untaken-list__single__icon
                t-icon" aria-hidden="true"></i>
            </div>
          </li>
        </ol>
      </template>

      <template v-if="!quizzesUntaken.length">
        <div class="c-card--quizzes__untaken-empty">
          <i class="fa fa-thumbs-up c-card--quizzes__untaken-empty__icon t-icon"></i>
          <p class="c-card--quizzes__untaken-empty__text">
            {{ $t('web.card_quizzes.no_quizzes_available') }}
          </p>
        </div>
      </template>

      <template v-if="quizzesTaken.length">
        <h3 class="c-card--quizzes__taken-header qa-heading-taken">
          {{ $t('web.card_quizzes.completed_quizzes') }}
        </h3>
        <ol class="c-card--quizzes__taken-list">
          <li v-for="(quiz, i) in quizzesTaken">
            <button
              disabled
              class="c-card--quizzes__taken-list__single qa-open-modal-button-disabled"
            >
              {{ quiz.name }}
            </button>
          </li>
        </ol>
      </template>
    </div>

    <!--
      - v-show ensures the form state persists if the user closes the modal before submitting.
      - Separating modals from buttons prevents modals from being removed from the DOM
        after a quiz is marked taken.
    -->
    <portal to="modal">
      <div
        class  = "c-modal c-modal--quiz"
        v-for  = "quiz in quizzes"
        :key   = "quiz.code"
        v-show = "modalIsVisible(quiz.code)"
      >
        <section class="c-modal__box c-modal--quiz__box">
          <div class="c-modal__box__header t-modal-header">
            <h2 class="c-modal__box__header__title t-modal-header__text">
              {{  quiz.name }}
            </h2>

            <div class="c-modal__box__header__close">
              <button
                @click = "hideModal"
                class  = "c-modal__box__header__close__button
                          t-modal-header__close
                          qa-close-modal-button"
              >
                <i class="fa fa-close"></i>
              </button>
            </div>
          </div>

          <div :ref="quiz.code + '-quiz'" class="c-modal--quiz__wrapper__quiz"></div>
        </section>


        <div class="c-modal__overlay"></div>
      </div>
    </portal>
  </div>
</template>




<script>
import { clone, get } from 'lodash'
import { makeWidget } from '@typeform/embed'
import $ from 'jquery'

export default {
  name: 'QuizzesCard',

  props: {
    card: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      quizzes: [],
      visibleModal: ''
    }
  },

  computed: {
    /**
     * Determine if the card data is loading.
     *
     * @return {boolean}
     */
    loading () {
      return !this.card.cardLoaded
    },

    /**
     * Get quizzes the participant has already taken.
     *
     * @return {array}
     */
    quizzesTaken () {
      return this.quizzes.filter(quiz => quiz.taken)
    },

    /**
     * Get quizzes the participant has not yet taken.
     *
     * @return {array}
     */
    quizzesUntaken () {
      return this.quizzes.filter(quiz => !quiz.taken)
    }
  },

  methods: {
    /**
     * Hide the displayed modal.
     *
     * @return {void}
     */
    hideModal () {
      $('body').removeClass('has-modal')
      this.visibleModal = ''
    },

    /**
     * Load a quiz from Typeform.
     *
     * @param {quizCode} string
     * @return {void}
     */
    loadQuiz (quizCode) {
      if (typeof this.$refs[quizCode + '-quiz'] === 'undefined') {
        return
      }
      makeWidget(this.$refs[quizCode + '-quiz'][0], quizCode, {
        onSubmit: () => {
          this.markQuizTaken(quizCode)
        }
      })

      this.$set(this.quizzes.find(quiz => quiz.code === quizCode), 'alreadyShown', true)
    },

    /**
     * Mark a quiz as taken.
     *
     * @param string quizCode
     * @return {void}
     */
    markQuizTaken (quizCode) {
      this.$set(this.quizzes.find(quiz => quiz.code === quizCode), 'taken', true)
    },

    /**
     * Determine if a modal is visible.
     *
     * @param {string} quizCode
     * @return {boolean}
     */
    modalIsVisible (quizCode) {
      return this.visibleModal === quizCode
    },

    /**
     * Show a modal.
     *
     * @param {number} quizCode
     * @return {void}
     */
    showModal (quizCode) {
      $('body').addClass('has-modal')
      this.visibleModal = quizCode
      this.$nextTick(() => {
        this.loadQuiz(quizCode)
      })
    }
  },

  watch: {
    /**
     * Once quizzes data comes back from the API call, assign it to the data
     * property for reactivity.
     *
     * @param {array} newQuizzes New value assigned to quizzes.
     * @return {void}
     */
    'card.quizzes' (newQuizzes) {
      this.quizzes = clone(newQuizzes)
    }
  },

  created () {
    // When navigating back to this page, reuse previously fetched data rather
    // than waiting for it to load again.
    this.quizzes = get(this.card, 'quizzes', [])
  }
}
</script>



// WEBPACK FOOTER //
// Quizzes.vue?2a1f766f